<template>
  <v-container fluid fill-height justify-center id="scrolling-techniques-7" class="overflow-y-auto" key="login">
    <v-row class="max-w">
      <v-col cols="12">
        <v-form
          ref="form"
          v-model="valid"
          lazy-validation
          class="mx-4"
        >
          <!--<div class="headline font-weight-medium mb-6 text-center">
            {{ $t('boilerTemp') }}
          </div>-->

          <div class="subtitle-1 font-weight-medium mb-4 text-center accent--text">
            {{ $t('temp-zadana') }}
          </div>

          <div class="d-flex justify-space-between align-center">
            <div>
              <v-btn class="ma-2" fab color="accent" @click="boilerTempSetting--">
                <v-icon>mdi-minus</v-icon>
              </v-btn>
            </div>
            <div class="display-1 accent--text">
              {{ boilerTempSetting }} &deg;C
            </div>
            <div>
              <v-btn class="ma-2" fab color="accent" @click="boilerTempSetting++">
                <v-icon>mdi-plus</v-icon>
              </v-btn>
            </div>
          </div>

          <div class="my-3 px-7 accent--text noselect">
            <v-slider
              v-model="boilerTempSetting"
              color="accent"
              :min="boilerTempMin"
              :max="boilerTempMax"
            >
              <template v-slot:prepend>
                {{ boilerTempMin }}
              </template>
              <template v-slot:append>
                {{ boilerTempMax }}
              </template>
            </v-slider>
          </div>

          <div class="subtitle-1 font-weight-medium mb-4 text-center secondary--text">
            {{ $t('temp-obn') }}
          </div>

          <div class="d-flex justify-space-between align-center">
            <div>
              <v-btn class="ma-2" fab color="secondary" @click="boilerTempReducedSetting--">
                <v-icon>mdi-minus</v-icon>
              </v-btn>
            </div>
            <div class="display-1 secondary--text">
              {{ boilerTempReducedSetting }} &deg;C
            </div>
            <div>
              <v-btn class="ma-2" fab color="secondary" @click="boilerTempReducedSetting++">
                <v-icon>mdi-plus</v-icon>
              </v-btn>
            </div>
          </div>

          <div class="my-3 px-7 secondary--text noselect">
            <v-slider
              v-model="boilerTempReducedSetting"
              color="secondary"
              :min="boilerTempReducedMin"
              :max="boilerTempReducedMax"
            >
              <template v-slot:prepend>
                {{ boilerTempReducedMin }}
              </template>
              <template v-slot:append>
                {{ boilerTempReducedMax }}
              </template>
            </v-slider>
          </div>

          <div class="d-flex mt-5 t-primary justify-center">
            <v-btn 
              :loading="saving"
              :disabled="saving" 
              @click="postForm"
              x-large 
              class="mx-1" 
              color="primary"
              >{{ $t('zapisz') }}</v-btn>
            <v-btn x-large text class="mx-1" @click="$router.go(-1)">{{ $t('anuluj') }}</v-btn>
          </div>
        </v-form>
      </v-col>
    </v-row>
  </v-container>

</template>

<script>
export default {
  data: () => ({
    valid: true,
    boilerTempSetting: 0,
    boilerTempReducedSetting: 0
  }),
  computed: {
    controllerId() {
      return this.$route.params.controllerId;
    },
    moduleName() {
      return 'c' + this.controllerId;
    },
    params () {
      return this.$store.state[this.moduleName].params
    },
    boilerTempMin() {
      return this.$store.state[this.moduleName].boilerTempMin
    },
    boilerTempMax() {
      return this.$store.state[this.moduleName].boilerTempMax
    },
    boilerTempReducedMin() {
      return this.$store.state[this.moduleName].boilerTempReducedMin
    },
    boilerTempReducedMax() {
      return this.$store.state[this.moduleName].boilerTempReducedMax
    },
    saving() {
      if (this.$store.state[this.moduleName] !== undefined) {
        return this.$store.state[this.moduleName].saving
      } else {
        return true
      }
    }
  },
  created () {
    //przekieruj na dashboard jesli wejscie bezposrednie, a moze lepiej zarejestrowac modul i zsynchronizowac dane?
    if (!(this.$store && this.$store.state && this.$store.state[this.moduleName])) {
      this.$router.push({ path: '/dashboard/' + this.controllerId });
    } else {
      this.boilerTempSetting = parseInt(this.params.boilerTempSet);
      this.boilerTempReducedSetting = parseInt(this.params.boilerTempReduced);
    }
  },
  methods: {
    validate () {
    },
    postForm () {
      this.$store.dispatch(`${this.moduleName}/setBoilerTemp`, { 
        boilerTempSet: this.boilerTempSetting, 
        boilerTempReduced: this.boilerTempReducedSetting 
      }).then(res => {
        if (res.error) {
          this.$store.commit("alert", {
            color: "error",
            text: res.error.code
          });
        } else {
          this.$store.commit("alert", {
            color: "success",
            timeout: 900,
            ok: true,
            text: 'OK'
          });
          this.$router.push({ path: '/dashboard/' + this.controllerId });
        }
      });
    }
  },
}
</script>

<style>
  .btn-back {
    margin-left: -8px;
  }
</style>

